export const INCREMENT_COMMENT_LIKE_COUNT_REQUEST = 'comment/INCREMENT_LIKE_COUNT_REQUEST';
export const INCREMENT_COMMENT_LIKE_COUNT_SUCCESS = 'comment/INCREMENT_LIKE_COUNT_SUCCESS';
export const INCREMENT_COMMENT_LIKE_COUNT_FAILURE = 'comment/INCREMENT_LIKE_COUNT_FAILURE';
